import SettlementPaymentsAutocomplete from "./SettlementPaymentsAutocomplete";
import SettlementPaymentsModalField from "./SettlementPaymentsModalField";

export default function SettlementPaymentsPartyFields({ casePk, values, onChange }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <SettlementPaymentsModalField
        label="Payment From *"
        renderValue={
          <SettlementPaymentsAutocomplete
            casePk={casePk}
            fieldName="paymentFrom"
            fieldValue={values.paymentFrom}
            onChange={onChange}
          />
        }
      />
      <SettlementPaymentsModalField
        label="Payment To *"
        renderValue={
          <SettlementPaymentsAutocomplete
            casePk={casePk}
            fieldName="paymentTo"
            fieldValue={values.paymentTo}
            onChange={onChange}
          />
        }
      />
      <SettlementPaymentsModalField
        label="Intended Recipient"
        renderValue={
          <SettlementPaymentsAutocomplete
            casePk={casePk}
            fieldName="intendedRecipient"
            fieldValue={values.intendedRecipient}
            onChange={onChange}
          />
        }
      />
    </div>
  );
}
